import { get } from 'lodash';
import * as uuid from 'uuid';

import { API_URL as BASE_API_URL } from '@funnels/constants';
import { MOCK_DATA } from '@funnels/mockdata';
import { ServerLiabilityCreate, ServerLiabilityFetch, ServerLiabilityUpdate } from '@funnels/types';

import { fixOwnershipForAPI, fixOwnershipFromAPI } from '../_common';
import { axios } from '../_common/axios';

const SHOULD_USE_MOCK_API = localStorage.getItem('_lendi_funnels_debug_use_mock_api') === 'true';
const API_URL = `${BASE_API_URL}/v1`;

function create(applicationId: string, liability: ServerLiabilityCreate): Promise<any> {
  if (SHOULD_USE_MOCK_API) {
    return Promise.resolve({ data: { id: uuid.v4() } });
  }

  return axios
    .post(`${API_URL}/applications/${applicationId}/liabilities`, fixOwnershipForAPI(liability))
    .then((res) => res.data);
}

function del(applicationId: string, liabilityId: string): Promise<any> {
  if (SHOULD_USE_MOCK_API) {
    return Promise.resolve();
  }

  return axios.delete(`${API_URL}/applications/${applicationId}/liabilities/${liabilityId}`).then((res) => res.data);
}

function fetch(applicationId: string): Promise<any> {
  if (SHOULD_USE_MOCK_API) {
    return Promise.resolve({ data: MOCK_DATA.liabilities });
  }

  return axios.get(`${API_URL}/applications/${applicationId}/liabilities`).then((res) => {
    if (Array.isArray(get(res, 'data.data'))) {
      res.data.data.map((a: ServerLiabilityFetch) => fixOwnershipFromAPI(a));
    }
    return res.data;
  });
}

function update(applicationId: string, liabilityId: string, liability: ServerLiabilityUpdate): Promise<any> {
  if (SHOULD_USE_MOCK_API) {
    return Promise.resolve();
  }

  return axios
    .put(`${API_URL}/applications/${applicationId}/liabilities/${liabilityId}`, fixOwnershipForAPI(liability))
    .then((res) => res.data);
}

export default { create, del, fetch, update };
